






























export default {
  name: "BreadCrumbs",
  props: {
    list: { type: Array, default: () => [] },
  },
};
